<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     等级选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="level" :placeholder="placeholder" clearable @change="selectChange" @visible-change="visibleChange" :style="{ width: width ? width + 'px' : '100%' }">
    <el-option
      v-for="(item, index) in levels"
      :key="index"
      :label="item.customer_level + '星'"
      :value="item.customer_level">
      <span style="float: left" class="mr-lg">
        <el-rate v-model="item.customer_level" disabled-void-color="transparent" disabled></el-rate>
      </span>
      <span style="float: right;" class="font-md">{{ item.member_count }}</span>
    </el-option>
  </el-select>

</template>

<script>
import { levelsApi } from '@/api/up/upMemberApi'

export default {
  name: "LevelSelector",

  props: {
    value: {
      type: [Number, String],
      default: 0
    },

    placeholder: {
      type: String,
      default: '等级'
    },

    width: {
			type: String,
			default: ''
		}
  },

  data() {
    return {
      levels: []
    }
  },

  computed: {
    level: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
  },

  created() {
    this.fetchList()
  },

  methods: {
    fetchList() {
      levelsApi().then(res => {
        if (!res.errno) {
          const arr = [...res.data.levels].reverse()
          this.levels = arr
        }
      })
    },

    visibleChange(val) {
      if (val) {
        this.fetchList()
      }
    },

    selectChange(val) {
      const list = this.levels.map(v => v.value)
      const index = list.indexOf(val)
      const item = this.levels[index]
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-rate {
  height: 34px;
  line-height: 34px;
}
/deep/ .el-rate__icon {
  line-height: 34px;
}
</style>